import { FormGroup, FormControl, ValidationErrors, ValidatorFn, AbstractControl } from '@angular/forms';
import { isArray, isNull } from 'util';

export abstract class ValidForm {

  static numeric(c: FormControl): ValidationErrors {
    const params = {
      numeric: {}
    };
    return c.value === '' || (!isNaN(parseFloat(c.value)) && isFinite(c.value)) ? null : params;
  }

  static emptyNumeric(c: FormControl): ValidationErrors {
    const params = {
      numeric: {}
    };

    if (c.value === '' || c.value === null) {
      return null;
    } else {
      return !isNaN(parseFloat(c.value)) && isFinite(c.value) ? null : params;
    }
  }

  static email(c: FormControl): ValidationErrors {
    const params = {
      email: {}
    };
    return !c.value ||
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        c.value
      )
      ? null
      : params;
  }

  static username(value: number): ValidatorFn {
    return (c: FormControl): ValidationErrors => {
      const params = {
        username: {}
      };

      return c.value === '' || c.value == null || (c.value.length >= value && /\d/.test(c.value)) ? null : params;
    };
  }

  static password(value: number): ValidatorFn {
    return (c: FormControl): ValidationErrors => {
      const params = {
        password: {}
      };

      return c.value === '' || c.value == null || (c.value.length >= value && /\d/.test(c.value) && /[A-Z]/.test(c.value)) ? null : params;
    };
  }
  static string(c: FormControl): ValidationErrors {
    const params = {
      string: {}
    };
    return c.value === '' || c.value == null ||
      /^[A-Za-z\s]+$/.test(c.value)
      ? null
      : params;
  }

  static equalField(field: string): ValidatorFn {
    return (c: FormControl): ValidationErrors => {
      const sub = c.parent.controls[field].statusChanges.subscribe(val => {
        c.updateValueAndValidity();
        sub.unsubscribe();
      });

      const value = c.parent.controls[field].value;
      const params = {
        equalField: {
          equal: value
        }
      };

      return c.value === value ? null : params;
    };
  }

  static confirmPassword(field_name: string): ValidatorFn {
    return (control: FormControl): { [key: string]: any } => {
      let password = control.value;
      let isvalid = control.root.value[field_name] == password
      if (!isvalid) {
        return { mismatchePasswords: true }
      } else {
        return null;
      }
    }
  }

  static generic(c: FormControl, regExp: RegExp): ValidationErrors {
    const params = {
      generic: {}
    };
    return !c.value || regExp.test(c.value) ? null : params;
  }

  static validFileExtension(exts: string[] = ['.pdf']): ValidatorFn {

    return (c: FormControl): { [key: string]: any } => {
 

      if (c.value === '' || c.value === null) {
        return null;
      } else {
        const exten = ( c.value.substring(c.value.lastIndexOf('.'))).toLowerCase();
        const params = {
          extension: {
            extens: exts.join(',')
          }
        };
        if (exts.includes(exten)) {
          return null;
        } else {
          return params;
        }
      }
    };

  }

  static largerThan(field: string): ValidatorFn {
    return (c: FormControl): ValidationErrors => {

      const value = c.parent.controls[field].value;
      const params = {
        largerThan: {
          equal: value
        }
      };

      return (c.value == null && value == null) || (c.value === "" && value == null) || (c.value == null && value === "") || (c.value === "" && value === "") || (parseInt(c.value) >= parseInt(value)) ? null : params;
    };
  }


  static notspace(c: FormControl): ValidationErrors {
    const params = {
      notspace: {string: c.value}
    };
    return !c.value ||
      !/\s/.test(c.value)
      ? null
      : params;
  }
  // static validFinalPeriod(field_name: string): ValidatorFn {
  //   console.log('field_name', field_name);
  //   return (control: FormControl): { [key: string]: any } => {
  //     const  n = (isNull(control.value));
  //     const isvalid = control.root.value[field_name] <= n;
  //     if (!isvalid) {
  //       return { finalPeriod: false };
  //     } else {
  //       return null;
  //     }
  //   };
  // }


  static segments(cant: number, delimiter:string): ValidatorFn {
    return (c: FormControl): { [key: string]: any } => {

      const params = {
        segments: { cant: cant + 1, delimiter: delimiter }
      };
      let regex = new RegExp("[\.]".replace('.', delimiter), 'gi');

      let match: any[] = (c.value) ? (c.value.match(regex)) ? c.value.match(regex) : [] : [];
      return !c.value || c.dirty == false || match.length == cant ? null : params;
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/shared/services/ValidForm.ts